import React from 'react';
import { TextComponent } from 'baseComponents/TextComponent';
import './resultsTableElementComponent.scss';

interface Props {
  title: string;
  value: string;
}

export const ResultsTableElementComponent: React.FC<Props> = (props) => {
  return (
    <div className='results-element-wrapper'>
      <TextComponent size='middle-large' opacity text={props.title} />
      <TextComponent size='large' text={props.value} />
    </div>
  );
};
